export const hasToken = ({ token }) => !!token